import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRealtimeUnits, useRealtimeDrivers } from 'Core/hooks';
import { useIntl } from "react-intl";
// Actions
import {
  setDriversEntity,
  getDriverFaces,
  updateVidFleetTSPDriver,
  updateDriver,
  deleteVidFleetFaceId,
  deleteVidFleetDriverCollection,
  resetDriverFaceState,
} from "Redux/actions";
// Components
import { Grid, Container, Box } from "@mui/material";

import { Toolbar } from "Components/uiControls";
import Pill from "Components/Pill";
import {
  // Area,
  // AreaMenu,
  Button,
  Card,
  IconButton,
  // Menu,
  Modal,
  RadioGroup,
  Select,
} from "@gpstrackit/gtc-react-controls";
import TableView from "Components/TableView";
import { CarouselComp as Carousel } from "Modules/.common/components/Corousel";
import { NotificationManager } from "Components/Notifications";
import { HasPermission } from "Core/security";
import { Filters } from "./components/filters";
import { DeleteCollection } from "./components/deleteCollection";
import { DeleteFace } from "./components/deleteFace";
import { AssignFaceToDriver } from "./components/assignFaceToDriver";

const DriverFaces = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const tableViewRef = useRef();

  const selectedEntity = useSelector((state) => state.driverRedux.entity);
  const {
    facesData,
    total,
    loadingFaceData,
    loadingUpdateTSPDriver,
    responseTSPDriver,
    loadingDeleteFaceId,
    responseDeleteFaceId,
    loadingDeleteDriverCollection,
    responseDeleteDriverCollection,
  } = useSelector((state) => state.driverFacesSliceRedux);
  const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
  const userSecurity = useSelector((state) => state.securityRedux.user);
  const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selected, setSelected] = useState([]);
  const [favoriteUrl, setFavoriteUrl] = useState("");
  const [filter, setFilter] = useState("all");
  const [openModal, seOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalDeleteFaceId, setOpenModalDeleteFaceId] = useState(false);
  const [faceIdDelete, setFaceIdDelete] = useState("");
  const [driverSelected, setDriverSelected] = useState();
  const [dataWithDrivers, setDataWithDrivers] = useState([]);

  // Permissions
  const editablePermissions = HasPermission(userSecurity, "", [342]);

  const entities = [
    {
      name: messages["settingsDriver_drivers"],
      id: "drivers",
    },
    {
      name: messages["settingsDriver_tags"],
      id: "tags",
    },
  ];

  if (HasPermission(userSecurity, ["fcscoll"])) {
    entities.push({
      name: messages["settingsDriver_driversFaces"],
      id: "driverFaces",
    });
  }

  useEffect(() => {
    setSelected([]);
    dispatch(
      getDriverFaces({
        includes: filter,
        limit: 10,
        offset: 0,
      })
    );
  }, [filter]);

  useEffect(() => {
    if (facesData?.length === 0) return setDataWithDrivers([]);
    const addDriverLabel = facesData?.map((item) => {
      if (item?.tspDriver) {
        const driver = item?.tspDriver.split("_")[1];
        const driverLabel = drivers.find((item) => item?.driverId == driver);
        return {
          ...item,
          driverName: driverLabel?.name,
        };
      } else {
        return item;
      }
    });
    setDataWithDrivers(addDriverLabel);
  }, [facesData]);

  useEffect(() => {
    if (responseTSPDriver === "success") {
      NotificationManager.success(
        messages["settingsDriver_driversFacesUpdateSuccess"],
        messages["success"],
        3000,
        null,
        null,
        "success",
        null
      );
      reloadSearch();
    }

    if (responseTSPDriver === "error") {
      NotificationManager.error(
        messages["settingsDriver_driversFacesUpdateError"],
        messages["error"],
        3000,
        null,
        null,
        "error",
        null
      );
    }

    dispatch(
      resetDriverFaceState({
        responseTSPDriver: "",
      })
    );
  }, [responseTSPDriver]);

  useEffect(() => {
    if (responseDeleteDriverCollection === "success") {
      NotificationManager.success(
        messages["settingsDriver_driversFacesDeleteCollectionSuccess"],
        messages["success"],
        3000,
        null,
        null,
        "success",
        null
      );

      reloadSearch();
    }

    if (responseDeleteDriverCollection === "error") {
      NotificationManager.error(
        messages["settingsDriver_driversFacesDeleteCollectionError"],
        messages["error"],
        3000,
        null,
        null,
        "error",
        null
      );
    }

    dispatch(
      resetDriverFaceState({
        responseDeleteDriverCollection: "",
      })
    );
  }, [responseDeleteDriverCollection]);

  useEffect(() => {
    if (responseDeleteFaceId === "success") {
      NotificationManager.success(
        messages["settingsDriver_driversFacesDeleteCollectionSuccess"],
        messages["success"],
        3000,
        null,
        null,
        "success",
        null
      );

      reloadSearch();
    }

    if (responseDeleteFaceId === "error") {
      NotificationManager.error(
        messages["settingsDriver_driversFacesDeleteCollectionError"],
        messages["error"],
        3000,
        null,
        null,
        "error",
        null
      );
    }

    dispatch(
      resetDriverFaceState({
        responseDeleteFaceId: "",
      })
    );
  }, [responseDeleteFaceId]);

  const handleChangePage = useCallback((newPage, newRowsPerPage) => {
    const realPage = newPage - 1;
    dispatch(
      getDriverFaces({
        includes: filter,
        limit: newRowsPerPage || rowsPerPage,
        offset: realPage * (newRowsPerPage || rowsPerPage),
      })
    );
  });

  const assignDrivers = () => {
    const driversId = [];
    selected?.map((item) => driversId.push(item?.driverID));
    dispatch(
      updateVidFleetTSPDriver({
        driverId: driverSelected?.driverId,
        vidFleetDriversIds: driversId,
      })
    );

    if (favoriteUrl) {
      dispatch(
        updateDriver({
          id: driverSelected?.driverId,
          tempAvatarUrl: favoriteUrl,
        })
      );
    }

    setDriverSelected();
  };

  const reloadSearch = () => {
    setSelected([]);
    dispatch(
      getDriverFaces({
        includes: filter,
        limit: 10,
        offset: 0,
      })
    );
  };

  const deleteDriverCollection = () => {
    const driverIds = [];
    selected?.map((item) => driverIds.push(item?.driverID));
    dispatch(
      deleteVidFleetDriverCollection({
        driverIds,
      })
    );
  };

  const deleteFaceId = () => {
    dispatch(
      deleteVidFleetFaceId({
        faceId: faceIdDelete,
      })
    );
  };

  const getVhLabel = (item) => {
    let cameraSN = "";
    item?.faces?.map((face) => {
      if (face?.cameraSN?.length > 0) return (cameraSN = face?.cameraSN);
    });

    const getUnit = units?.find(
      (unit) => unit?.esn === cameraSN || unit?.linkedUnit?.esn === cameraSN
    );

    return getUnit?.label;
  };

  const canAssign = () => {
    let flag = true;
    if (selected.length === 0) flag = false;
    selected?.map((item) => {
      if (item?.tspDriver?.length > 0) {
        flag = false;
      }
    });
    return flag;
  };

  return (
    <Container maxWidth={false}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={4}>
          <Toolbar>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Filters filter={filter} setFilter={setFilter} />
              {selected.length > 0 && (
                <>
                  <Grid
                    item
                    style={{
                      marginLeft: 5,
                    }}
                  >
                    <IconButton
                      tooltip={
                        messages["settingsDriver_driversFacesCleanSeleted"]
                      }
                      variant="secondary"
                      icon="deselect"
                      placement="top"
                      isDisabled={selected.length > 0 ? false : true}
                      onClick={() => setSelected([])}
                    />
                  </Grid>
                  {editablePermissions &&
                    <Grid
                      item
                      style={{
                        marginLeft: 5,
                      }}
                    >
                      <IconButton
                        tooltip={
                          messages[
                          "settingsDriver_driversFacesDeleteCollectionTitle"
                          ]
                        }
                        variant="secondary"
                        icon="deleteIcon"
                        placement="top"
                        isDisabled={selected.length > 0 ? false : true}
                        onClick={() => setOpenModalDelete(true)}
                      />
                    </Grid>
                  }
                </>
              )}
            </Grid>
          </Toolbar>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          style={{ textAlign: "center", marginBottom: 8 }}
        >
          {entities.map((entity, index) => {
            return (
              <Pill
                key={index}
                textField={"name"}
                item={entity}
                outlined={selectedEntity?.id != entity?.id}
                onClick={() => {
                  dispatch(setDriversEntity(entity));
                }}
                style={{ border: "0" }}
                label="pill-label-text"
                colorField="default"
                colorSelection="005bf8"
              />
            );
          })}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          style={{ textAlign: "end", marginBottom: 8 }}
        >
          <Button
            isDisabled={!canAssign()}
            onClick={() => {
              if (canAssign()) {
                seOpenModal(true);
              }
            }}
          >
            {messages["settingsDriver_driversFacesAssign"]}
          </Button>
        </Grid>
      </Grid>
      <TableView
        ref={tableViewRef}
        data={dataWithDrivers || []}
        loading={loadingFaceData}
        rowsPerPage={rowsPerPage}
        name="Table View"
        topSpaceSize={330}
        sizeInput={3}
        viewType="card"
        messages={messages}
        inputSearch={false}
        hideAllInPagination
        showCheck={false}
        renderRow={(row) => {
          const vhLabel = getVhLabel(row);
          return (
            <Card heigth="360px">
              {editablePermissions &&
                <Carousel
                  item={row}
                  expandImage={true}
                  selected={selected}
                  vhLabel={vhLabel}
                  setSelected={(item) => setSelected(item)}
                  onClickDelete={(e) => {
                    setFaceIdDelete(e);
                    setOpenModalDeleteFaceId(true);
                  }}
                />
              }
              {!editablePermissions &&
                <Carousel
                  item={row}
                  expandImage={true}
                  selected={selected}
                  vhLabel={vhLabel}
                  setSelected={(item) => setSelected(item)}
                />
              }
            </Card>
          );
        }}
        toolbarContainerClassName="table-toolbar-container"
        total={total}
        onChangePage={(page) => {
          handleChangePage(page);
        }}
        serverSide
        onChangeRowsPerPage={(newRowsPerPage, newPage) => {
          setRowsPerPage(newRowsPerPage);
          handleChangePage(newPage, newRowsPerPage);
        }}
      />
      <AssignFaceToDriver
        openModal={openModal}
        seOpenModal={seOpenModal}
        setDriverSelected={setDriverSelected}
        driverSelected={driverSelected}
        selected={selected}
        favoriteUrl={favoriteUrl}
        setFavoriteUrl={setFavoriteUrl}
        drivers={drivers}
        assignDrivers={assignDrivers}
      />
      <DeleteCollection
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        selected={selected}
        setSelected={setSelected}
        deleteDriverCollection={deleteDriverCollection}
      />
      <DeleteFace
        openModalDeleteFaceId={openModalDeleteFaceId}
        setFaceIdDelete={setFaceIdDelete}
        setOpenModalDeleteFaceId={setOpenModalDeleteFaceId}
        deleteFaceId={deleteFaceId}
      />
    </Container>
  );
};

export default DriverFaces;
